import { createContext, useState, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "app/components";
import { empresasService } from "app/services";
import { useParams } from "react-router-dom";
import { ErrorMessage } from "app/components/error-message";

const CelularContext = createContext();

const initialState = {
  celular_numero: "",
  celular_principal: false,
};

export function CelularProvider({ children }) {
  const params = useParams();

  const [celular, setCelular] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const celularQuery = useQuery({
    queryKey: ["empresa:get:celular", params.empresa_id, params.celular_id],
    queryFn: () =>
      empresasService.getCelular({
        empresaId: params.empresa_id,
        celularId: params.celular_id,
      }),
    onSuccess: (data) => {
      setCelular(data);

      setEditing(true);
    },
    enabled: !!params.celular_id,
  });

  if (!!celularQuery.isLoading && !!params.celular_id) {
    return <Spinner label="Cargando el número de celular..." />;
  } else if (!!celularQuery.isFetching && !!params.celular_id) {
    return <Spinner label="Recuperando el número de celular..." />;
  } else if (!!celularQuery.isRefetching && !!params.celular_id) {
    return <Spinner label="Recargando el número de celular..." />;
  } else if (!!celularQuery.isError) {
    return <ErrorMessage message={celularQuery.error.response.statusText} />;
  }

  return (
    <CelularContext.Provider
      value={{
        celular,
        setCelular,
        isEditing,
      }}
    >
      {children}
    </CelularContext.Provider>
  );
}

export function useCelularContext() {
  const celularContext = useContext(CelularContext);

  if (!celularContext) {
    throw new Error(
      "useCelularContext should be used inside the CelularProvider."
    );
  }

  return celularContext;
}
